export const apiEndPoints = {
  // media Uploads
  imageUpload: '/api/images/upload/images',
  videoUpload: '/api/images/upload-video/videos',
  pdfUpload: '/api/images/upload/pdf',
};
